import { render, staticRenderFns } from "./ContainerSidebar.vue?vue&type=template&id=6cb45812&scoped=true&"
import script from "./ContainerSidebar.vue?vue&type=script&lang=js&"
export * from "./ContainerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ContainerSidebar.vue?vue&type=style&index=0&id=6cb45812&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb45812",
  null
  
)

component.options.__file = "ContainerSidebar.vue"
export default component.exports